module.exports = __webpack_public_path__ + "media/icons/new-daf3efb6.svg";